var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0V5.33h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 10.662H0v5.333h24v-5.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M14.085 5.563h-1.388l.233-1.74.922-.69.93.69v1.395l-.697.345zm-4.17 0h1.388l-.233-1.74-.922-.69-.93.69v1.395l.697.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12.93 5.563h-1.86v-1.74l.93-.69.93.69v1.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.217 5.217v3.825a2.775 2.775 0 001.118 2.25l.487-.12.615.615c.185.04.374.06.563.06.188-.002.376-.02.562-.052l.698-.585.405.082a2.798 2.798 0 001.117-2.25V5.217H9.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.328 5.217h-1.11v1.11h1.11v-1.11zm2.227 0h-1.11v1.11h1.11v-1.11zm2.228 0h-1.11v1.11h1.11v-1.11zm-3.345 1.11h-1.11v1.11h1.11v-1.11zm2.227 0h-1.11v1.11h1.11v-1.11zm-3.337 1.118h-1.11v1.11h1.11v-1.11zm1.11 1.11h-1.11v1.11h1.11v-1.11zm1.117-1.11h-1.11v1.11h1.11v-1.11zm2.228 0h-1.11v1.11h1.11v-1.11zm-1.118 1.11h-1.11v1.11h1.11v-1.11zm-1.11 1.117h-1.11v1.11h1.11v-1.11zm-2.227 0H9.293c.09.408.275.788.54 1.11h.495v-1.11zm3.345 1.11h.495c.264-.322.45-.702.54-1.11h-1.036v1.11zm-3.345 0v.488c.333.242.714.414 1.117.503v-.99h-1.117zm2.227 0v.968a3 3 0 001.117-.502v-.488l-1.117.023z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/Croatia.68735483b652b8c672b5e57619656908.svg";
export { ForwardRef as ReactComponent };